// Static fitting-type metadata per ADR 0001 scope boundary:
// twoXfour ships UX with placeholder content; Libra wires to CMS/SF.
//
// Canonical `name` strings confirmed against SF on 2026-06-04 — the names
// here must match the SF Apex /Availability fitting record names exactly,
// otherwise the call 400s (e.g., the earlier `Full Bag w/o Putter` issue).
// Source of truth: the legacy widget's dataLayer `e.detail.fittingSelection`.
//
// Pricing is shown as "FREE w/ club purchase OR $X flat" — the wireframes
// show a single national price; pricing varies by location in reality. That
// remains a Libra/Druv refinement; we hardcode national-tier prices here.

import type { FittingType } from '../types';

export const FITTING_TYPES: FittingType[] = [
  {
    id: 'full-bag',
    name: 'Full Bag',
    description: 'The most comprehensive fitting in the industry, covering all woods, irons, wedges, and putter.',
    durationLabel: '3 hours',
    durationMinutes: 180,
    pricingLabel: 'FREE w/ custom club purchase or $400 flat fitting fee',
  },
  {
    id: 'full-bag-wo-putter',
    name: 'Full Bag (No Putter)',
    description: 'The most comprehensive fitting in the industry, covering all woods, irons, wedges.',
    durationLabel: '2.5 hours',
    durationMinutes: 150,
    pricingLabel: 'FREE w/ custom club purchase or $400 flat fitting fee',
    badge: 'MOST POPULAR',
  },
  {
    id: 'driver',
    name: 'Driver',
    description: 'Find more power off the tee with this focused fitting.',
    durationLabel: '1.5 hours',
    durationMinutes: 90,
    pricingLabel: 'FREE w/ custom club purchase or $175 flat fitting fee',
    badge: 'POPULAR',
  },
  {
    id: 'iron',
    name: 'Iron',
    description: 'Improve your control with a broad selection of the best clubheads and shafts available.',
    durationLabel: '1.5 hours',
    durationMinutes: 90,
    pricingLabel: 'FREE w/ custom club purchase or $175 flat fitting fee',
    badge: 'POPULAR',
  },
  {
    id: 'putter',
    name: 'Putter',
    description: 'Get the ball rolling properly and on-line with this unique fitting.',
    durationLabel: '1 hour',
    durationMinutes: 60,
    pricingLabel: 'FREE w/ custom club purchase or $125 flat fitting fee',
    badge: 'POPULAR',
  },
  {
    id: 'full-bag-start',
    // SF canonical is `Full Bag - Start`; product/UX label is `Full Bag (split session)`.
    name: 'Full Bag - Start',
    displayName: 'Full Bag (split session)',
    description: 'The full-bag fitting scope (woods, irons, wedges, putter) delivered across two sessions.',
    durationLabel: '3 hours',
    durationMinutes: 180,
    pricingLabel: 'FREE w/ custom club purchase or $400 flat fitting fee',
  },
  {
    id: 'long-game',
    // SF canonical is `Complete Long Game`; product/UX label is `Long Game`.
    name: 'Complete Long Game',
    displayName: 'Long Game',
    description: 'Combine your driver, fairway woods, and hybrids in this value-based fitting option.',
    durationLabel: '2 hours',
    durationMinutes: 120,
    pricingLabel: 'FREE w/ custom club purchase or $250 flat fitting fee',
  },
  {
    id: 'fairway-wood-hybrid',
    name: 'Fairway Wood/Hybrid',
    description: 'Attack every lie imaginable after dialing in these clubs for optimal launch angle and swing speed.',
    durationLabel: '1 hour',
    durationMinutes: 60,
    pricingLabel: 'FREE w/ custom club purchase or $125 flat fitting fee',
  },
  {
    id: 'wedge',
    name: 'Wedge',
    description: 'Check in on your lofts, bounce and gapping with this short game saver.',
    durationLabel: '1 hour',
    durationMinutes: 60,
    pricingLabel: 'FREE w/ custom club purchase or $100 flat fitting fee',
  },
];
